import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges,
} from "@angular/core";
import { CoreTreeComponent } from "./core-tree.component";
import { ICAreaApi } from "../../../models/apis/icarea.api";
import { ICAreaFilter } from "../../../models/filters/icarea.filter";

@Component({
  selector: "app-area-tree",
  styleUrls: [
    "../../../../scss/vendors/bs-datepicker/bs-datepicker.scss",
    "../../../../scss/vendors/ng-select/ng-select.scss",
  ],
  templateUrl: "area-tree.component.html",
})
export class AreaTreeComponent
  extends CoreTreeComponent
  implements OnInit, OnChanges
{
  @Input() showSearch: boolean = false;
  searchResults: { ancestors: string[]; area: ICAreaApi }[] = [];
  private searchTimeout: any;

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  triggerSearch() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.search();
    }, 500);
  }

  async search() {
    if (!this.searchTerm) {
      this.searchResults = [];
      return;
    }

    const filter = new ICAreaFilter({
      SearchQuery: this.searchTerm,
      UserId: (await this.userSrv.current()).Id,
    });

    if (this.area && this.area.Id) {
      filter.AreaIds = [this.area.Id];
    }

    const result = await this.areaSrv.list(filter, false);
    if (result && result.Success) {
      this.searchResults = result.ListResult.map((node) => {
        const ancestors = node.AreaTree ? node.AreaTree.split(" / ") : [];
        // Remove the node's own name from ancestors if it's there
        const nodeName =
          node.Name && node.Name.length > 0 ? node.Name[0].Value : "";
        if (
          ancestors.length > 0 &&
          ancestors[ancestors.length - 1].trim() === nodeName.trim()
        ) {
          ancestors.pop();
        }
        return { ancestors, area: node };
      });
    } else {
      this.searchResults = [];
    }
  }

  collectAllFilteredIdsRecursive(ids: number[]) {
    if (this.searchTerm) {
      this.searchResults.forEach((match) => {
        if (
          this.selectable &&
          match.area.Id != 0 &&
          ((this.OnlyLevels &&
            this.OnlyLevels.indexOf(match.area.Level) > -1) ||
            !this.OnlyLevels ||
            this.OnlyLevels.length == 0)
        ) {
          ids.push(match.area.Id);
        }
      });
    } else {
      super.collectAllFilteredIdsRecursive(ids);
    }
  }
}
